// extracted by mini-css-extract-plugin
export default {"newsletter":"page7_newsletter__xB2YJ","input":"page7_input__b38GR"};